import { motion } from "framer-motion";
import Hero from "@/components/Hero";
import ChatPanel from "@/components/ChatPanel";
import EmojiRow from "@/components/EmojiRow";
import Footer from "@/components/Footer";
import BackgroundBlobs from "@/components/BackgroundBlobs";

export default function Landing() {
  return (
    <main className="relative isolate min-h-screen">
      <BackgroundBlobs />

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 sm:px-6 pt-10 sm:pt-16 pb-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        >
          <Hero />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
          className="mt-10 sm:mt-14"
        >
          <ChatPanel />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.16, ease: [0.22, 1, 0.36, 1] }}
        >
          <EmojiRow />
        </motion.div>

        <Footer />
      </div>
    </main>
  );
}
